import { Box, Button } from "@mui/material"
import { FlightDetailsTabKey } from "./flightDetails"

type FlightDetailsHeadingProps = {
    heading: { key: FlightDetailsTabKey; label: string }
    selectedDetails: FlightDetailsTabKey
    setSelectedDetails: (details: FlightDetailsTabKey) => void
}

const FlightDetailsHeadings = ({ heading, selectedDetails, setSelectedDetails }: FlightDetailsHeadingProps) => {
    return (
        <Box
            sx={(theme) => ({
                width: '50%',
                borderBottom: heading.key === selectedDetails
                    ? `2px solid ${theme.palette.primary.main}`
                : '2px solid transparent',
                cursor: 'pointer'
            })}
        >
            <Button
                variant="text"
                sx={(theme) => ({
                    fontSize: '1rem', width: '100%', color: heading.key === selectedDetails ? theme.palette.primary.main : '#1F2937'         
                })}
                onClick={() => setSelectedDetails(heading.key)} 
            >
                {heading.label}
            </Button>
        </Box>
    )
}

export default FlightDetailsHeadings